module.exports = __webpack_public_path__ + "static/media/language_class_demo.7439ccb8.png";